module.exports = __webpack_public_path__ + "img/skv_queek_0.bc2906a0.png";